// Layout.js
import React, { useEffect, useState } from "react";
import { Menu as MenuIcon } from "lucide-react";
import { Outlet, useLocation } from "react-router-dom";
import MenuComponent from "../components/menu/MenuComponent";
import NavbarProfileComponent from "../components/menu/NavbarProfileComponent";
import LanguageSwitcher from "../components/LanguageSwitcher";
import '../style/global.css'
import '../style/layout.css'
import { useTranslation } from "react-i18next";

const LayoutMain = () => {

  const location = useLocation();
  const { t, i18n } = useTranslation();
  // Sidebar sebagai panel geser di layar < 992px (HP & tablet)
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Mengambil path dan memisahkan berdasarkan "/"
  const pathParts = location.pathname
    .split('/')
    .filter((part) => part !== ''); // Menghapus elemen kosong jika ada

  // Segmen URL diterjemahkan lewat common:breadcrumb.<segmen>; segmen yang tidak dikenal
  // (mis. ID) ditampilkan dalam Title Case.
  const formatText = (text) => {
    const key = `breadcrumb.${text.toLowerCase()}`;
    const translated = t(key);
    if (translated !== key) return translated;

    return text
      .replace(/-/g, ' ') // Mengganti tanda "-" dengan spasi
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Membuat huruf pertama dari setiap kata menjadi besar
  };

  return (
    <div className="app-container">
      <div className="sidebar">
        <MenuComponent toggled={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      </div>
      <main>
        {/* Header: judul halaman di kiri; perusahaan, bahasa & profil di kanan */}
        <header className="app-topbar">
          <button
            type="button"
            className="app-topbar__menu-btn"
            aria-label={t("menu.title")}
            aria-expanded={sidebarOpen}
            onClick={() => setSidebarOpen(true)}
          >
            <MenuIcon size={22} aria-hidden="true" />
          </button>
          <nav className="app-topbar__breadcrumb" aria-label="breadcrumb">
            {pathParts.map((part, index) => (
              <span
                key={`${part}-${index}`}
                className={index === pathParts.length - 1 ? "is-current" : ""}
                aria-current={index === pathParts.length - 1 ? "page" : undefined}
              >
                {formatText(part)}
              </span>
            ))}
          </nav>
          <div className="app-topbar__actions">
            <LanguageSwitcher placement="topbar" />
            <NavbarProfileComponent />
          </div>
        </header>
        <div className="app-content">
          {/* key bahasa: halaman di-remount saat bahasa berganti agar teks tr() ikut berganti */}
          <Outlet key={i18n.language} />
        </div>
      </main>
    </div>
  );
  
};

export default LayoutMain;